import { render } from "./ScoreDGV.vue?vue&type=template&id=225ab909&scoped=true"
import script from "./ScoreDGV.vue?vue&type=script&lang=js"
export * from "./ScoreDGV.vue?vue&type=script&lang=js"

import "./ScoreDGV.vue?vue&type=style&index=0&id=225ab909&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225ab909"]])

export default __exports__